import { Typography } from "@graphy/ui";
import Image, { StaticImageData } from "next/image";

export type HeroStatsPropsType = {
  text: string;
  avatars: {
    src: StaticImageData;
    alt: string;
  }[];
};

const HeroStats = ({ text, avatars = [] }: HeroStatsPropsType) => {
  return (
    <div className="inline-flex items-center gap-1.5 rounded-full bg-yellow-0 px-3 py-1 text-yellow-4">
      <div className="flex items-center">
        {avatars.map((avatar, index) => (
          <div
            key={index}
            className="-ml-1.5 rounded-full border border-yellow-0"
          >
            <Image height={16} width={16} src={avatar.src} alt={avatar.alt} />
          </div>
        ))}
      </div>
      <Typography
        fontSize="text-caption"
        fontWeight="font-normal"
        colorClass="text-yellow-4"
      >
        {text}
      </Typography>
    </div>
  );
};

export default HeroStats;
